/* eslint-disable newline-before-return */
import { FC, ChangeEvent, useState } from 'react';
import {
  Grid,
  TextArea,
  Button,
  Container,
  Input,
  Dropdown,
  Message,
  Popup,
  Form,
  // Checkbox,
} from 'semantic-ui-react';
import { getFeedBackFromOpenAIWithTurbo } from '../../util/index';

const options = [
  { key: '1', text: 'Email Inquiry', value: 'Email Inquiry' },
  {
    key: '2',
    text: 'Casual Chat Inquiry',
    value: 'Casual Chat Inquiry',
  },
  {
    key: '3',
    text: 'Formal Chat Inquiry',
    value: 'Formal Chat Inquiry',
  },
  {
    key: '4',
    text: 'Non-Academic Short Essay',
    value: 'Non-Academic Short Essay',
  },
  {
    key: '5',
    text: 'Academic Short Essay',
    value: 'Academic Short Essay',
  },
  {
    key: '6',
    text: 'IELTS Part 2 Essays (over 250 words)',
    value: 'IELTS Part 2 Essays (over 250 words)',
  },
  {
    key: '7',
    text: 'GitHub Issue Submission',
    value: 'GitHub Issue Submission',
  },
];

const Component: FC = () => {
  const [text, setText] = useState('');
  // const [turbo, setTurbo] = useState(true);
  const [statusText, setStatusText] = useState('ここに結果が表示されます');
  const [score, setScore] = useState(0);
  const [fontColor, setColor] = useState('black');
  const [apiKey, setApiKey] = useState(undefined);
  const [selectedOption, setSelectedOption] = useState('');
  const [body, setBody] = useState('');
  const [feedback, setFeedback] = useState('');

  const copyToClipboard = async () => {
    await global.navigator.clipboard.writeText(body);
  };

  const handleApiKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setApiKey(e.target.value);
  };

  const handleDropdownChange = (e: React.SyntheticEvent, data: any) => {
    setSelectedOption(data.value);
  };

  const getFeedback = async () => {
    setStatusText('Now thinking...');
    setBody('');
    setFeedback('');
    const result = await getFeedBackFromOpenAIWithTurbo(
      text,
      selectedOption,
      apiKey
    );

    setBody(result.body);
    setScore(result.score);
    setFeedback(result.feedback);
    if (result.score < 40) {
      setColor('red');
    } else if (result.score < 60) {
      setColor('orange');
    } else if (result.score < 80) {
      setColor('blue');
    } else {
      setColor('green');
    }
    setStatusText('ここに結果が表示されます');
  };
  //
  return (
    <>
      <Grid>
        <Grid.Row>
          <Container style={{ display: 'flex', alignItems: 'center' }}>
            <Form>
              <Form.Field>
                <label>Open API key</label>
                <Input
                  placeholder="API Key"
                  value={apiKey}
                  onChange={handleApiKeyChange}
                  style={{ marginRight: '1rem' }}
                />
              </Form.Field>
            </Form>
            <Form>
              <Form.Field>
                <label>Situation</label>
                <Dropdown
                  placeholder="Select an option"
                  selection
                  options={options}
                  onChange={handleDropdownChange}
                  defaultValue={'Email Inquiry'}
                />
              </Form.Field>
            </Form>
            <p style={{ margin: '20px', fontSize: '24px', color: fontColor }}>
              <span style={{ color: 'gray' }}>Your score:</span> {score}
            </p>
          </Container>
        </Grid.Row>
        <Grid.Row columns="equal">
          <Grid.Column width={8}>
            <p>Your text:</p>
            <TextArea
              placeholder=""
              style={{ minHeight: 300, width: '100%' }}
              onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                setText(event.target.value);
              }}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <p>OpenAI:</p>
            <TextArea
              disabled
              value={body}
              placeholder={statusText}
              style={{ minHeight: 300, width: '100%' }}
            />
            <Container style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Popup
                content="Copied!"
                on="click"
                trigger={
                  <Button
                    icon="copy"
                    size="small"
                    onClick={copyToClipboard}
                    style={{
                      position: 'absolute',
                      bottom: '1em',
                      right: '2em',
                    }}
                  />
                }
              />
            </Container>
          </Grid.Column>
        </Grid.Row>
        <details>
          <summary>FeedBack {feedback !== '' && '(1)'}</summary>
          {feedback !== '' && (
            <Grid.Row columns="equal">
              <Grid.Column width={16}>
                <Message info>
                  <Message.Header>Feedback</Message.Header>
                  <p>{feedback}</p>
                </Message>
              </Grid.Column>
            </Grid.Row>
          )}
        </details>
        <Grid.Row columns="equal">
          <Grid.Column width={4}>
            <Button
              content="FeedBack"
              disabled={text === '' || statusText === 'Now thinking...'}
              color="blue"
              onClick={getFeedback}
            />
          </Grid.Column>
          {/* <Checkbox
            id="turbo"
            label="More faster, but more expensive"
            onChange={() => setTurbo(!turbo)}
          /> */}
        </Grid.Row>
      </Grid>
    </>
  );
};

export default Component;
